import debounce from 'lodash.debounce';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import MasterPermissions from 'src/Admin/api/MasterPermissions';
import { axiosInstance } from 'src/api/axios';

const usePublishMessageList = (selectedTab = 'messages') => {
  const navigate = useNavigate();
  //Published Message Filters
  const SortOptionsList = [
    {
      label: 'Latest',
      value: 'desc',
    },
    {
      label: 'Oldest',
      value: 'asc',
    },
  ];
  const [sortByData, setSortByData] = useState(SortOptionsList[0]);

  const [searchText, setSearchText] = useState('');
  const [search, setSearch] = useState('');

  const isSuperUser = useSelector((state) => state?.user?.userData?.SuperUser);

  const [
    PUBLISH_NEW_MESSAGE_USER_OPTIONS,
    setPUBLISH_NEW_MESSAGE_USER_OPTIONS,
  ] = useState([]);

  const getAllowedUserTypeOptions = () => {
    const DATA = [];
    if (MasterPermissions.CheckPermission('To Member/Dependents')) {
      DATA.push({
        label: 'TO MEMBERS & DEPENDENTS',
        value: 'Member',
      });
    }
    if (MasterPermissions.CheckPermission('To Providers')) {
      DATA.push({ label: 'TO PROVIDERS', value: 'Provider' });
    }
    if (MasterPermissions.CheckPermission('To Brokers')) {
      DATA.push({ label: 'TO BROKERS', value: 'Broker' });
    }
    if (MasterPermissions.CheckPermission('To Insurers')) {
      DATA.push({ label: 'TO INSURERS', value: 'Insurer' });
    }
    if (MasterPermissions.CheckPermission('To Employers')) {
      DATA.push({ label: 'TO EMPLOYERS', value: 'Client' });
    }
    //if (isSuperUser) {
    //DATA.push({ label: 'TO ALL USERS', value: 'TO ALL USERS' });
    //}
    setPUBLISH_NEW_MESSAGE_USER_OPTIONS([...DATA]);
  };

  useEffect(() => {
    getAllowedUserTypeOptions();
  }, []);

  const handleChangePublishMessage = async (item) => {
    console.log('Call Download Report API', item);
    navigate('/admin/publish-new-message', { state: item?.value });
  };

  //published message list
  const { Sender_Email } = useSelector(
    (state) => state?.app?.appConfigs?.Email_Configration,
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const displayPaginationMininumCount = 10;

  const pageSizeHandler = useCallback((pageSizeInfo) => {
    setCurrentPage(1);
    setPageSize(pageSizeInfo.value);
    //eslint-disable-next-line
  }, []);

  const showingRecordsMessage = () => {
    let message = '';
    message = `Showing ${currentPage * pageSize - pageSize + 1} - ${
      pageSize * currentPage < totalRecords
        ? pageSize * currentPage
        : totalRecords
    } of ${totalRecords} results`;
    return message;
  };

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [messageDetailData, setMessageDetailData] = useState(null);

  const ListUser = (index, item) => {
    setSelectedIndex(index);
    setMessageDetailData(item);
  };

  const [listLoading, setListLoading] = useState(false);

  const [listApiDataNotFoundError, setListApiDataNotFoundError] =
    useState(false);
  const [isListApiServerError, setIsListApiServerError] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const debouncedCall = useCallback(
    debounce((currentVal) => setSearch(currentVal), 800),
    [],
  );

  const onSearch = (event) => {
    setCurrentPage(1);
    setSearchText(event.target.value);
    debouncedCall(event.target.value);
  };

  const getSendReceiveMessageList = async () => {
    setListLoading(true);
    let filterParams = '';
    if (sortByData?.value) {
      filterParams =
        filterParams + `sortby/createddate/sortdirection/${sortByData?.value}`;
    }
    if (searchText?.length > 2) {
      filterParams = filterParams + `/eventsearchkey/${searchText}`;
    }
    if (currentPage) {
      filterParams = filterParams + `/pagenumber/${currentPage}`;
    }
    if (pageSize) {
      filterParams = filterParams + `/pagesize/${pageSize}`;
    }

    try {
      setListApiDataNotFoundError(false);
      setIsListApiServerError(false);
      const publishedMessageListResp = await axiosInstance.get(
        `${APIEndpoints.getPublishedMessageResources()}${
          filterParams && `/${filterParams}`
        }`,
      );
      const { Pagination } = publishedMessageListResp?.data?.Response || {
        PageNumber: 1,
        PageSize: 10,
        TotalRecords: 0,
      };
      const responseMessageList =
        publishedMessageListResp.data.Response.PPMessaging;
      const listData = [];
      if (responseMessageList?.length > 0) {
        responseMessageList.map((item, index) => {
          listData.push({
            id: item?.Oid || index,
            indexValue: index,
            FirstName: '',
            LastName: '',
            EventTitle: item?.eventtitle,
            EventDesc: item?.eventdesc,
            userType: item?.usertype,
            attachments: item?.PPMessageDocumentDTO?.length > 0,
            ReceivedDateTime: item?.createddate,
          });
          return 0;
        });
        setFilteredData(listData);
        setSelectedIndex(0);
        setMessageDetailData(listData[0]);
        setTotalRecords(Pagination?.TotalRecords);
      } else if (responseMessageList?.length === 0) {
        setListApiDataNotFoundError(true);
        setIsListApiServerError(true);
      }
    } catch (error) {
      console.log('error :', error);
      if (error.toString().includes('404')) {
        setListApiDataNotFoundError(true);
        setIsListApiServerError(true);
      }
      setIsListApiServerError(true);
      setFilteredData([]);
      setTotalRecords(0);
    } finally {
      setListLoading(false);
    }
  };

  const getSanitizedContent = (content) => {
    console.log('content?.EventDesc', content?.EventDesc);
    return content
      ? {
          ...content,
          EventDesc: content.EventDesc.replace(/=\\/g, '=').replace(/\\n/g, ''),
        }
      : content;
  };

  useEffect(() => {
    if (selectedTab === 'published-messages') getSendReceiveMessageList();
  }, [selectedTab, search, sortByData, currentPage, pageSize]);

  return {
    SortOptionsList,
    sortByData,
    setSortByData,
    PUBLISH_NEW_MESSAGE_USER_OPTIONS,
    handleChangePublishMessage,
    searchText,
    setSearchText,
    //listData,
    ListUser,
    selectedIndex,
    messageDetailData,
    showingRecordsMessage,
    currentPage,
    setCurrentPage,
    pageSize,
    setPageSize,
    totalRecords,
    setTotalRecords,
    displayPaginationMininumCount,
    pageSizeHandler,
    filteredData,
    getSendReceiveMessageList,
    listLoading,
    listApiDataNotFoundError,
    isListApiServerError,
    Sender_Email,
    onSearch,
    search,
    getSanitizedContent,
  };
};

export default usePublishMessageList;
